import Card from '@Utils/Card';
import React from 'react';
import InputSelector from '@Component/form/InputSelector';
import './surveyBaseStyles.scss';
import { useQuestionContext } from './questionsSection';

function SurveyWelcomeNote(props) {
  const attributes = useQuestionContext();

  return (
    <Card>
      <div className="question-header">
        <span className="section-title">Welcome Note</span>
      </div>
      <div
        id="welcome-editor"
        className="question-content question-with-content"
      >
        <InputSelector
          {...attributes}
          isRich
          type="rich"
          showAttributePicker
          showEmojiPicker
          placeholder="welcome..."
          value={props?.value?.body ?? ''}
          onChange={(body) => {
            props.onChange({ ...props?.value, body });
          }}
        />
      </div>
    </Card>
  );
}

export { SurveyWelcomeNote };
